import React, { FC } from 'react'

const ProductSlider:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/product-slider.png" alt=''/>
        </div>
    </div>
  )
}

export default ProductSlider